import { render } from "./Copyright.vue?vue&type=template&id=ed2ac370&scoped=true"
const script = {}

import "./Copyright.vue?vue&type=style&index=0&id=ed2ac370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2ac370"]])

export default __exports__